import actionTypes from "../action-types";

export function receivePremiumTrials({ trials }: any) {
  return {
    type: actionTypes.RECEIVE_PREMIUM_TRIALS,
    payload: trials
  };
}

export function studyWrongAnswerSession() {
  return {
    type: actionTypes.STUDY_WRONG_ANSWER_SESSION
  };
}
